(function(){
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    document.body.classList.add('av-shell');
    var stickyAtc=document.getElementById('aviri-sticky-atc');
    if(stickyAtc && stickyAtc.parentElement!==document.body){ document.body.appendChild(stickyAtc); }
    var path=location.pathname;
    var nav=document.getElementById('av-navbar');
    var back=document.getElementById('av-back');
    if(path==='/'){ back.classList.add('av-hide'); }
    back.addEventListener('click', function(){
      if(window.history.length>1){ history.back(); } else { location.href='/'; }
    });
    nav.querySelectorAll('[data-av]').forEach(function(el){
      var key=el.dataset.av;
      var isActive = (key==='home'&&path==='/') || (key==='cart'&&path.indexOf('/cart')===0) || (key==='account'&&path.indexOf('/account')===0) || (key==='menu'&&path.indexOf('/collections')===0);
      if(isActive) el.classList.add('av-active');
    });
    var menuBtn=nav.querySelector('[data-av="menu"]');
    var searchBtn=nav.querySelector('[data-av="search"]');
    var cartBtn=nav.querySelector('[data-av="cart"]');
    if(menuBtn) menuBtn.addEventListener('click', function(e){
      e.stopPropagation();
      var s=document.querySelector('summary.header__icon--menu'); if(s) s.click();
    });
    if(searchBtn) searchBtn.addEventListener('click', function(e){
      e.stopPropagation();
      var s=document.querySelector('summary.header__icon--search'); if(s) s.click();
    });
    if(cartBtn) cartBtn.addEventListener('click', function(e){
      e.stopPropagation();
      var c=document.getElementById('cart-icon-bubble'); if(c) c.click();
    });
    function hookToggle(summarySel){
      var s=document.querySelector(summarySel);
      var d=s ? s.closest('details') : null;
      if(!d) return;
      d.addEventListener('toggle', function(){
        var open=d.open;
        nav.classList.toggle('av-hide', open);
        back.classList.toggle('av-hide', open || path==='/');
      });
    }
    hookToggle('summary.header__icon--menu');
    hookToggle('summary.header__icon--search');
    if(stickyAtc){
      function syncBackPos(){ back.classList.toggle('av-back--raised', stickyAtc.classList.contains('is-visible')); }
      syncBackPos();
      new MutationObserver(syncBackPos).observe(stickyAtc, {attributes:true, attributeFilter:['class']});
    }
    var badge=document.getElementById('av-cart-badge');
    function syncBadge(){
      fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
        if(c.item_count>0){ badge.textContent=c.item_count>99?'99+':c.item_count; badge.classList.add('on'); }
        else { badge.classList.remove('on'); }
      }).catch(function(){});
    }
    syncBadge();
    var cd=document.querySelector('cart-drawer');
    if(cd){
      var t=null;
      new MutationObserver(function(){ clearTimeout(t); t=setTimeout(syncBadge,400); }).observe(cd,{childList:true,subtree:true});
    }
  });
})();
